import store from '@/store/'

export default function impersonate({ next, router }) {
  if (!store.getters['user/can_access_ai_assistant']) {
    return router.push({ name: 'NotFound' })
  }

  return next()
}
